import Paginator from 'components/Pagination';
import React from 'react';
import { SearchCustomFooterView } from '../searchCustomFooterView';
import {
  usePerformSearch,
  useSearchFilters,
  useSearchResult,
} from 'redux/hooks/searchnFilter';
import { Pagination } from 'business/models/Models';
import {
  setCurrentPage,
  setPageSize,
  toggleDistinctRows,
} from 'redux/reducers/searchnFilterReducer';
import { useRMDispatch } from 'redux/hooks';

export const Footer = (props) => {
  const { className = 'h-full bg-gray-200 flex flex-row-reverse align-center px-3' } =
    props;
  const performSearch = usePerformSearch();
  const filters = useSearchFilters();
  const searchResult = useSearchResult();
  const dispatch = useRMDispatch();

  const onPageNumberChange = (pageNumber: number) => {
    performSearch(
      new Pagination({ page: pageNumber, perPage: searchResult.rows.pagination.perPage }),
    );
    dispatch(setCurrentPage(pageNumber));
  };

  const onPageSizeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    performSearch(new Pagination({ page: 1, perPage: parseInt(e.target.value) }));
    dispatch(setPageSize(parseInt(e.target.value)));
  };

  const onChangeDistinctRow = () => {
    dispatch(toggleDistinctRows());
  };

  return (
    <Paginator
      pagination={searchResult.rows.pagination}
      onPageNumberChange={onPageNumberChange}
      onPageSizeChange={onPageSizeChange}
      showRowsPerPage={false}
      showSimplifiedVersion
      containerStyle={className ? className : null}
      customView={
        <SearchCustomFooterView
          total={searchResult.rows.pagination.total}
          fetchedRecords={searchResult.rows.items.length}
          showDistinctRows={filters.distinctRows}
          onChangeDistinctRow={onChangeDistinctRow}
        />
      }
    />
  );
};
